module.exports = __webpack_public_path__ + "img/01.46f2dc6c.png";